import { EnumSignupSteps, SignupData } from 'modules/auth/types/signup'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useAuthenticatedUserQuery } from '../queries/useAuthenticatedUserQuery'
import { useSignupStoreActions } from '../store/useSignupStore'
import { SignupFormData } from './useSignupForm'

export const useSetDefaultSignupForm = () => {
  const { data: authenticatedUser, isLoading } = useAuthenticatedUserQuery({
    refetchOnWindowFocus: false,
  })

  const { reset } = useFormContext<SignupFormData>()
  const { updateSignupData, goToStep } = useSignupStoreActions()
  const [isFormReady, setIsFormReady] = useState(false)

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (!authenticatedUser) {
      goToStep(EnumSignupSteps.NAME)
      setIsFormReady(true)
      return
    }

    const authenticatedSignupData: SignupData = {
      email: authenticatedUser.email,
      firstname: authenticatedUser.firstname,
      lastname: authenticatedUser.lastname,
      password: '',
      userAcceptsTerms: true,
      allOptionalConsent: false,
      hasConsentedForMarketing: false,
      hasConsentedForThirdPartyCommunication: false,
    }

    // Reset form with authenticated user
    reset(authenticatedSignupData)

    goToStep(EnumSignupSteps.EMAIL_CONFIRM)

    setIsFormReady(true)
  }, [authenticatedUser, isLoading, goToStep, reset, updateSignupData])

  return {
    isFormReady: isFormReady && !isLoading,
  }
}
